import inView from 'in-view/dist/in-view.min';
import 'slick-slider';

export function slider() {

  $('.slider').slick({
    dots: true,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 5000,
    adaptiveHeight: true,
  });

  inView('.slider')
    .on('enter', el => {
      $(el).slick('slickSetOption', 'autoplay', true);
      $(el).slick( 'refresh' );
    })
    .on('exit', el => {
      $(el).slick('slickSetOption', 'autoplay', false);
      $(el).slick( 'refresh' );
    });

  $('.teaser-slider').slick({
    dots: false,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 5000,
    adaptiveHeight: true,
  });

  $('.teaser-slider-2').slick({
    dots: false,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 5000,
    adaptiveHeight: true,
  });

  inView('.teaser-slider')
    .on('enter', el => {
      $(el).slick('slickSetOption', 'autoplay', true);
      $(el).slick( 'refresh' );
    })
    .on('exit', el => {
      $(el).slick('slickSetOption', 'autoplay', false);
      $(el).slick( 'refresh' );
    });

}



// WEBPACK FOOTER //
// ./scripts/components/slider.js